<template>
  <v-item
    class="pa-3 mb-2"
    :value="classification"
    data-testid="reference-file-download-item"
  >
    <template #default="{ active, toggle }">
      <v-hover v-slot="{ hover }">
        <div
          class="reference-file-download-item d-flex justify-space-between"
          :class="getClass(active, hover)"
          @click="toggle"
        >
          <div>
            <div class="d-flex">
              <div
                class="reference-file-download-item__icon-bg mr-2 mt-1"
                :class="referenceFileItem.iconBackgroundClass"
              >
                <v-icon
                  class="mr-1"
                  size="16"
                  :class="referenceFileItem.iconClass"
                  :color="getIconColor(referenceFileItem, active)"
                >
                  {{ referenceFileItem.icon }}
                </v-icon>
              </div>
              <span
                class="subtitle-2 font-weight-bold"
                :class="getTextClass(active)"
              >
                {{ referenceFileItem.header }}
              </span>
            </div>
            <div
              class="text-body-small"
              :class="getTextClass(active)"
            >
              {{ filename }}
            </div>
          </div>
          <div>
            <v-chip small class="px-2" :class="getChipClass(active)">
              <span class="text-body-small font-weight-bold">
                {{ count.toLocaleString() }}
              </span>
            </v-chip>
          </div>
        </div>
      </v-hover>
    </template>
  </v-item>
</template>

<script>
import { Review } from '@/models';
import { RelevanceAssessment } from '@/enums';
import { makeStringUrlSafe } from '@/modules';

const CLASSIFICATION_RENDERING_PROPS = {
  [RelevanceAssessment.RELEVANT]: {
    header: 'Relevant',
    icon: 'check_circle',
    iconColor: 'success',
    selectedIconColor: 'success',
    iconBackgroundClass: 'white',
  },
  [RelevanceAssessment.NOT_RELEVANT]: {
    header: 'Not Relevant',
    icon: 'remove_circle',
    iconColor: 'error',
    selectedIconColor: 'error',
    iconBackgroundClass: 'white',
  },
  [RelevanceAssessment.NOT_SURE]: {
    header: 'Not Sure',
    icon: 'thumbs_up_down',
    iconColor: 'grey',
    selectedIconColor: 'white',
    iconClass: 'material-icons-outlined',
  },
  [RelevanceAssessment.UNSCREENED]: {
    header: 'Unscreened',
    icon: 'help',
    iconColor: 'grey darken-1',
    selectedIconColor: 'white',
  },
};

export default {
  name: 'ReferenceFileDownloadItem',
  props: {
    classification: {
      type: String,
      default: null,
    },
    count: {
      type: Number,
      default: 0,
    },
    review: {
      type: Review,
      default: null,
    },
  },
  computed: {
    referenceFileItem() {
      return CLASSIFICATION_RENDERING_PROPS[this.classification];
    },
    filename() {
      if (this.review !== null) {
        let name = makeStringUrlSafe(this.review.title);
        let suffix = makeStringUrlSafe(this.referenceFileItem.header);
        name = `${name}-${suffix}.ris`;
        return name;
      }
      return null;
    },
  },
  mounted() {
    this.$emit('change', { label: this.label, selected: true });
  },
  methods: {
    getClass(isActive, hover) {
      return {
        primary: isActive,
        ['grey lighten-4']: !isActive && !hover,
        ['grey lighten-5']: !isActive && hover,
      };
    },
    getTextClass(isActive) {
      return isActive ? 'white--text' : 'grey--text';
    },
    getIconColor(item, isActive) {
      return isActive ? item.selectedIconColor : item.iconColor;
    },
    getChipClass(isActive) {
      return isActive
        ? 'white primary--text'
        : 'grey lighten-3 grey--text text--darken-2';
    },
  },
};
</script>

<style scoped>
.reference-file-download-item {
  cursor: pointer;
}
.text-body-small {
  font-size: 10px;
}
/* Style background circle behind icon (used to fill in transparent areas with white). */
.reference-file-download-item__icon-bg {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
/* Position icon so it is covering the background circle completely. */
.reference-file-download-item__icon-bg i {
  position: absolute;
  top: -0.1rem;
  left: -0.09rem;
}
</style>
